export const MIGRATION_GUARD_SELECTOR = '[data-migration-guard="1"]'
export const MIGRATION_HOST_SELECTOR = 'app-migration-dialog'

type CheckVisibilityOptions = {
  checkOpacity?: boolean
  checkVisibilityCSS?: boolean
}

type ElementWithCheckVisibility = HTMLElement & {
  checkVisibility?: (options?: CheckVisibilityOptions) => boolean
}

function hasCheckVisibility(el: HTMLElement): el is ElementWithCheckVisibility {
  return typeof (el as ElementWithCheckVisibility).checkVisibility === 'function'
}

/** True when the migration lock overlay is present and actually visible on screen. */
export function isMigrationGuardElementVisible(el: Element | null): boolean {
  if (!el || !(el instanceof HTMLElement) || !el.isConnected) {
    return false
  }

  if (hasCheckVisibility(el)) {
    try {
      return el.checkVisibility({
        checkOpacity: true,
        checkVisibilityCSS: true,
      })
    } catch {
      // Fall through to manual checks.
    }
  }

  const style = window.getComputedStyle(el)
  if (
    style.display === 'none' ||
    style.visibility === 'hidden' ||
    style.visibility === 'collapse'
  ) {
    return false
  }

  const opacity = parseFloat(style.opacity)
  if (!Number.isNaN(opacity) && opacity < 0.05) {
    return false
  }

  if (style.pointerEvents === 'none') {
    return false
  }

  const rect = el.getBoundingClientRect()
  if (rect.width < 2 || rect.height < 2) {
    return false
  }

  if (el.hasAttribute('data-migration-guard')) {
    const vw = window.innerWidth
    const vh = window.innerHeight
    if (rect.width < vw * 0.9 || rect.height < vh * 0.9) {
      return false
    }
    const zIndex = parseInt(style.zIndex, 10)
    if (!Number.isNaN(zIndex) && zIndex < 9000) {
      return false
    }
  }

  return true
}

export function isMigrationLockOverlayVisible(): boolean {
  const guard = document.querySelector(MIGRATION_GUARD_SELECTOR)
  const host = document.querySelector(MIGRATION_HOST_SELECTOR)
  if (!guard || !host) {
    return false
  }
  return (
    isMigrationGuardElementVisible(host) &&
    isMigrationGuardElementVisible(guard)
  )
}
